export enum FilingTypeKey {
  General = 'general278',
  Confirmed = 'confirmed278',
  NonWorkflow = 'nonWorkflow', // For extension requests
}
